module.exports = __webpack_public_path__ + "static/img/third2_2_2.9ff07863.jpg";